import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  title: {
    display: "flex",
    lineHeight: "31px",
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  close: {
    display: "flex",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
  center: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
}));
